import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { getInitialViewportSize, addViewportCallback, removeViewportCallback } from '../../utils/windowEvents/ResizeEvents.js';
import { SimpleHeaderPresentation } from './SimpleHeaderPresentation.js';

var SimpleHeaderWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(SimpleHeaderWrapper, _React$Component);
  var _super = _createSuper(SimpleHeaderWrapper);
  function SimpleHeaderWrapper(props) {
    var _this;
    _classCallCheck(this, SimpleHeaderWrapper);
    _this = _super.call(this, props);
    _this.onViewportChange = function (viewport) {
      return _this.setState({
        isMobile: ["md", "sm", "xs"].includes(viewport)
      });
    };
    _this.state = {
      counter: 1,
      noAnimation: false,
      isMobile: ["md", "sm", "xs"].includes(getInitialViewportSize()),
      forceMobile: false
    };
    return _this;
  }
  _createClass(SimpleHeaderWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      addViewportCallback(this.onViewportChange);
      this.setState(function (prevState) {
        return {
          counter: prevState.counter + 1
        };
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeViewportCallback(this.onViewportChange);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.value !== this.props.value) {
        // render twice to update indicator
        this.setState(function (p) {
          return {
            open: false,
            counter: p.counter + 1,
            noAnimation: false
          };
        });
      }
      if (prevState.isMobile !== this.state.isMobile) {
        // render twice to update indicator
        this.setState(function (p) {
          return {
            counter: p.counter + 1,
            noAnimation: true
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        isMobile = _this$state.isMobile,
        forceMobile = _this$state.forceMobile,
        open = _this$state.open,
        noAnimation = _this$state.noAnimation;
      return /*#__PURE__*/React.createElement(SimpleHeaderPresentation, Object.assign({}, this.props, {
        activeElement: this.activeElement,
        activeRef: function activeRef(r) {
          return _this2.activeElement = r;
        },
        isMobile: forceMobile || isMobile,
        noAnimation: noAnimation,
        open: open,
        onOpenChange: function onOpenChange(newOpen) {
          return _this2.setState({
            open: newOpen
          });
        },
        onForceMobileChange: function onForceMobileChange(forceMobileValue) {
          return _this2.setState({
            forceMobile: forceMobileValue
          });
        }
      }));
    }
  }]);
  return SimpleHeaderWrapper;
}(React.Component);

export { SimpleHeaderWrapper };
